<!-- Це все кусок троля, немає в мене сил переписати цей треш тому зберігаю логіку, під вю .На жаль стек застраий та використовує в2юі, тому тут трохи хардкор-->


<template>
    <yes_no
        v-model="editSummMode"
        base_class="mt-3"
        title="Редагувати суми пропозицій">
    </yes_no>
    
    <div ref="pos_items" id="positions" style="height:600px;display: block"></div>
    
    <div id="positions_control" style="width: 100%; ">
        <div class="row">
            <div class="col-6">
                <div class="btn btn-outline-primary btn_auto_render mb-2 mt-2 waves-effect waves-themed" v-on:click="auto_distribute">Розподілити</div>
            </div>
        </div>
    </div>
    
</template>


<script>
import * as W2 from 'w2ui'
import Yes_no from "../../../../base/yes_no.vue";

window.w2ui    = W2.w2ui
window.w2grid  = W2.w2grid
window.w2field = W2.w2field
window.query   = W2.query
window.w2utils = W2.w2utils
window.w2popup = W2.w2popup





export default {
    name: 'protocol_positions',
    components: {Yes_no},
    props: {
        protocol: { type: Object, required: true }
    },
    data() {
        return {
            editSummMode: false,
        }
    },
    
    created() {
        EventBus.$on('winner_item_removed', ({ gridId }) => {
            this.calcParams(gridId);
        });
        
        EventBus.$on('grid_add', ({ gridId }) => {
            this.calcParams(gridId);
        });
        
        EventBus.$on('winners:reset', () => {
            this.$nextTick(() => this.clearWinners())
        });
        
        EventBus.$on('winners:auto_distribute',this.auto_distribute);
        
        EventBus.$on('tab-shown', (key) => {
            if (key === 'protocol_positions') {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        if (w2ui['positions']) {w2ui.positions.refresh()}
                    })
                })
            }
        });
        
    },
    
    mounted() {
        this.tryInit();
        
        jQuery(document).on('dblclick', '.add_all', (e) => {
            const $el = jQuery(e.currentTarget);
            const appId = $el.data('id') || String($el.data('app') || '').replace(/^app/, '');
            if (!appId) return;
            
            
            this.addAll(appId.replace(/^app/, ''));
        });
    },
    
    beforeUnmount() {
        if (w2ui['positions']) w2ui['positions'].destroy()
    },
    
    watch: {
        position_data: {
            handler() { this.tryInit() },
            deep: true
        }
    },
    
    methods: {
        tryInit() {
            // проверяем наличие DOM и данных
            if (!this.$refs.pos_items) return
            if (!this.position_data || !this.columns?.length) return
            
            let self = this;
            
            // пересоздаём если уже было
            if (w2ui['positions']) w2ui['positions'].destroy();
            
            this.fixNumber()
            
            // создаём грид
            window.$ && window.$().w2grid({
                name: 'positions',
                
                show: {
                    header: true,
                    lineNumbers: true,
                    toolbar: true,
                    footer: true
                },
                
                columns: this.fix_caption(this.columns),
                columnGroups: this.fix_caption(this.columnGroups),
                records: this.fix_caption(this.records),
                
                onDblClick(event) {
                    console.log('event_click',event);
                    
                    if (event.recid === 'S-1' && col && (col.field?.startsWith('app') || col.app?.startsWith('app'))) {
                        const appField = col.app || col.field;
                        const appId = appField.replace(/^app/, '');
                        this.addAll(appId); // ↓ метод ниже
                        return;
                    }
                    
                    
                    const grid = this;
                    if (grid.last.sel_col == null || isNaN(grid.last.sel_col)) return;
                    
                    const col = w2ui.positions.columns[grid.last.sel_col];
                    const field = col.field;
                    
                    if (field.startsWith("app") || field.startsWith("price")) {
                        if (self.editSummMode) {
                            self.showEditApp(grid.get(event.recid).id, col.app.substring(3));
                            return;
                        }
                        
                        const newgrid = col.app;
                        const id = col.app.substring(3);
                        const title = col.app_title;
                        const rec = grid.get(event.recid);
                        
                        if (!self.recAdded(newgrid, id, rec, title)) {
                            rec["quantity_protocol" + id] =
                                rec.quantity_protocol > parseFloat(rec["quantity_app_" + id])
                                    ? parseFloat(rec["quantity_app_" + id])
                                    : rec.quantity_protocol;
                            
                            rec["quantity_protocol"] =
                                parseFloat(rec["quantity_protocol"]) -
                                parseFloat(rec["quantity_protocol" + id]);
                            
                            
                            let icon = '<i class="fas fa-minus-circle rem_sel" win_id="' + newgrid + '" style="color: firebrick; cursor: pointer;"></i> '+title;
                            
                            if (w2ui[newgrid] === undefined) {
                                self.pushNewGrid(newgrid, icon);
                                EventBus.$emit("push_new_grid");
                            }
                            
                            self.protocol.position_grid_add.forEach(g => {
                                if (g.id === newgrid) {
                                    g.records_push.push({...rec});
                                }
                            });
                            
                            EventBus.$emit("push_grid_position", { grid: newgrid, record: rec });
                            
                            grid.refresh();
                            grid.selectNone();
                            self.calcParams();
                        }
                    }
                }
            });
            
            // рендерим в наш контейнер
            window.$(this.$refs.pos_items).w2render('positions')
            w2ui['positions'].show.header = true
            w2ui['positions'].refresh()
            this.addButtonToolbar()
            
            
            this.calcOptimumMin((summ_opt) => {
                this.applyTotals(
                    summ_opt,
                    this.protocol.calculated_sum.cur_sum,
                    0
                )
            });
        },
        
        async auto_distribute() {
            
            const main = w2ui.positions;
            if (!main || !Array.isArray(main.records)) return;
            
            IMC_CORE.showloading();
          //
            this.clearWinners();
            (this.protocol.position_grid_add || []).forEach(g => {
                if (w2ui[g.id]) w2ui[g.id].destroy();
            });
            this.protocol.position_grid_add = [];
            
            
            // 1) Собрать «позиции» с предложениями (app) и остатком по каждой позиции
            const positions = main.records.map(rec => {
                console.log('record_operate',rec);
                
                const posId = rec.id ?? rec.recid;
                const quantityLeft = parseFloat(rec.quantity_protocol ?? rec.quantity ?? 0) || 0;
                
                // собрать все предложения Price_{appId} и свободное количество по ним:
                const app = Object.keys(rec)
                    .filter(k => k.startsWith('Price_'))
                    .map(k => {
                        const appId = k.slice(6); // 'Price_10996' -> '10996'
                        const qApp  = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0;            // сколько просит контрагент
                        const qUsed = parseFloat(rec['quantity_protocol' + appId] ?? 0) || 0;        // уже распределено этому контрагенту
                        const free  = Math.max(0, qApp - qUsed);                                     // оставшееся к распределению
                        const price = parseFloat(rec[k] ?? 0) || 0;
                        
                        return { app_id: appId, price, quantity: free };
                    })
                    .filter(x => x.quantity > 0)                    // только те, где есть что раздать
                    .sort((a, b) => a.price - b.price);            // по возрастанию цены
                
                return { id: posId, source: rec, quantitytotal: quantityLeft, app };
            });
            
            // 2) Жадно распределяем: идём по позициям, покупаем у самых дешёвых
            const toPushByGrid = {}; // { app10996: [records...] }
            
            for (const pos of positions) {
                let toBuy = pos.quantitytotal;
                if (toBuy <= 0 || pos.app.length === 0) continue;
                
                for (const offer of pos.app) {
                    if (toBuy <= 0) break;
                    
                    const buy = Math.min(toBuy, offer.quantity);
                    if (buy <= 0) continue;
                    
                    const gridName = this.ensureWinnerGrid(offer.app_id); // создаст holder + w2ui при необходимости
                    
                    // копия записи для winner-грида
                    const copy = { ...pos.source };
                    copy['quantity_protocol' + offer.app_id] = buy;
                    
                    // в копии уменьшим общий остаток (косметика для консистентного отображения)
                    const baseLeft = parseFloat(copy.quantity_protocol ?? copy.quantity ?? 0) || 0;
                    copy.quantity_protocol = +(baseLeft - buy);
                    
                    (toPushByGrid[gridName] ||= []).push(copy);
                    toBuy -= buy;
                }
            }
            
            console.log(toPushByGrid);

            // 3) Прокинуть собранные записи в соответствующие winner-гриды (и holders)
            Object.entries(toPushByGrid).forEach(([gridName, rows]) => {
                // в holder
                const holder = this.protocol.position_grid_add.find(g => g.id === gridName);
                if (holder) holder.records_push.push(...rows);
                
                
                
                
                // если w2ui уже создан — добавляем и приводим высоту/перерисовываем
               /* if (w2ui[gridName]) {
                    
                    w2ui[gridName].add(...rows);
                    const h = w2ui[gridName].records.length * w2ui[gridName].recordHeight + 255 + 'px';
                    const box = document.getElementById(gridName);
                    if (box) {
                        box.style.height = h;
                        if (window.$) window.$('#' + gridName).w2render(gridName);
                        w2ui[gridName].resize();
                        w2ui[gridName].refresh();
                    }
                } else {
                    // компонент winners дорисует и сам зальёт records_push
                    EventBus.$emit('grid_add', { gridId: gridName });
                }*/
            });
            
            // 4) Финальный пересчёт и суммы
           // this.calcParams();
            IMC_CORE.hideloading();
        },
        
        addAll(appId) {
            const main = w2ui.positions;
            if (!main) return;
            
            const appGridName = 'app' + appId;
        
            
            
            // 1) Снести все уже созданные app-гриды и очистить список (как старый код "[id^='app']...")
            (this.protocol.position_grid_add || []).forEach(g => {
                if (w2ui[g.id]) w2ui[g.id].destroy();
            });
            this.protocol.position_grid_add = [];
            
            // 2) Создать пустой грид для выбранного контрагента
            const title = this.getAppTitle(appId);
            console.log('title',title);
            this.pushNewGrid(appGridName, `<i class="fas fa-minus-circle rem_sel" win_id="${appGridName}" style="color: firebrick; cursor:pointer;"></i> ${title}`);
            EventBus.$emit('push_new_grid'); // чтобы компонент winners отрисовал контейнер и w2ui-грид
            
            // 3) Прокинуть позиции: всё, что есть в quantity_app_{appId} (> 0)
            const toPush = [];
            main.records.forEach(rec => {
                const qWant = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0;
                if (qWant <= 0) return;
                
                // сколько можем отдать из остатка по позиции
                const totalLeft = parseFloat(rec.quantity_protocol ?? rec.quantity ?? 0) || 0;
                const give = Math.min(qWant, totalLeft);
                if (give <= 0) return;
                
                const copy = { ...rec };
                copy['quantity_protocol' + appId] = give;
                // локально уменьшим общий остаток для корректного пересчёта
                copy.quantity_protocol = +(totalLeft - give);
                
                toPush.push(copy);
            });
            
            if(toPush.length <= 0) {
                return;
            }
            
            // 4) Добавить в сам w2ui-грид (если он уже создан), либо в pending массив,
            //    который заберёт компонент winners при рендере
            const holder = this.protocol.position_grid_add.find(g => g.id === appGridName);
            if (holder) holder.records_push.push(...toPush);
            
            // Если w2ui уже есть — добавить прямо сейчас и подогнать высоту
            if (w2ui[appGridName]) {
                w2ui[appGridName].add(...toPush);
                const h = w2ui[appGridName].records.length * w2ui[appGridName].recordHeight + 255 + 'px';
                const box = document.getElementById(appGridName);
                if (box) {
                    box.style.height = h;
                    // рендер без jQuery
                    if (window.$) window.$('#' + appGridName).w2render(appGridName);
                    w2ui[appGridName].resize();
                    w2ui[appGridName].refresh();
                }
            } else {
                // грид дорисуется слушателем push_new_grid; winners сам зальёт records_push
                EventBus.$emit('grid_add', { gridId: appGridName });
            }
            
            // 5) Пересчёт всего (остатков/сумм) — как у тебя уже сделано
            this.calcParams();
        },
        
        ensureWinnerGrid(appId) {
            const gridName = 'app' + appId;
            if (!this.protocol.position_grid_add.find(g => g.id === gridName)) {
                const title = this.getAppTitle(appId);
                const header = `<i class="fas fa-minus-circle rem_sel" win_id="${gridName}" style="color: firebrick; cursor:pointer;"></i> ${title}`;
                this.pushNewGrid(gridName, header);
                EventBus.$emit('push_new_grid'); // winners создаст контейнер и w2ui-грид
            }
            return gridName;
        },
        
        pushNewGrid($name, $title) {
            
            const neededFields = [
                'id',
                'title',
                'quantity_protocol' + $name.substring(3),
                'quantity_' + $name.substring(3),
                'app' + $name.substring(3),
                'price_val_' + $name.substring(3)
            ]
            
            const columns = this.position_data.columns.filter(col =>
                neededFields.includes(col.field)
            )
            
            const summaryKeys = ['S-1', 'S-2', 'S-3', 'S-4']
            const summary = this.position_data.records.filter(r =>
                summaryKeys.includes(r.recid)
            )
            
            this.protocol.position_grid_add.push({
                'id'        : $name,
                'title'     : $title,
                'columns'   : columns,
                'summary'   : summary,
                'records_push' : [],
            });
            
        },
        
        showEditApp(appId, contragentId) {
            console.log("edit_app", { appId, contragentId });
            EventBus.$emit('app:edit', { appId, contragentId });
        },
        
        clearWinners() {
            const grid = window.w2ui?.positions;
            if (grid && Array.isArray(grid.records)) {
                grid.records.forEach((rec) => {
                    const base = parseFloat(rec.quantity ?? 0) || 0;
                    
                    // общий остаток = исходная quantity
                    rec.quantity_protocol = base;
                    
                    // все per-app quantity_protocol{ид} в 0
                    Object.keys(rec).forEach((k) => {
                        if (/^quantity_protocol\d+$/.test(k)) rec[k] = 0;
                        if (/^Sum_\d+$/.test(k)) rec[k] = 0;                   // суммы по app в ноль
                        if (/^app\d+$/.test(k)) rec[k] = '';                   // «крашеные» ячейки очистить
                    });
                });
                try { grid.refresh(); } catch (e) {}
            }
            
            this.calcOptimumMin((summ_opt) => {
                this.applyTotals(summ_opt, 0, 0)
            });
            
        },
        
        calcParams(remname) {
            if (!w2ui.positions) return;
            
            const selectedvals = {};
            let summ_current = 0;
            let summ_ower = 0;
            
            const possibleGrids = new Set();
            (this.protocol.position_grid_add || []).forEach(g => {
                if (g && g.id) possibleGrids.add(g.id);
            });
            Object.keys(w2ui).forEach(k => {
                if (k && k.startsWith('app')) possibleGrids.add(k);
            });
            
            // пройдем по каждому grid (если он существует в w2ui)
            Array.from(possibleGrids).forEach(gridId => {
                const grid = w2ui[gridId];
                if (!grid || !Array.isArray(grid.records)) return;
                
                const appId = gridId.replace(/^app/, ''); // 'app10996' -> '10996'
                grid.records.forEach(rec => {
                    // ключи
                    const qKey = 'quantity_protocol' + appId;
                    const pKey = 'Price_' + appId;
                    const sKey = 'Sum_' + appId;
                    
                    // числовые значения
                    const q = parseFloat(rec[qKey] || 0) || 0;
                    const price = parseFloat(rec[pKey] || 0) || 0;
                    const sum = +(price * q).toFixed(2);
                    
                    // обновим вычисляемые поля в записи winner-грида
                    rec[sKey] = sum;
                    if (price === parseFloat(rec.min || 0)) {
                        rec['app' + appId] = `<div style="cursor: pointer; background-color:green; color:white; padding: 2px;">${sum}</div>`;
                    } else {
                        rec['app' + appId] = `<div style="cursor: pointer; padding: 2px;">${sum}</div>`;
                    }
                    
                    // если это remname — НЕ ДОБАВЛЯЕМ вклад этого грида (эквивалент обнуления вклада)
                    if (remname && gridId === remname) {
                        // пропускаем — вклад не учитывается
                        return;
                    }
                    
                    // агрегируем по позиции (rec.id)
                    const posId = rec.id;
                    if (!selectedvals[posId]) {
                        selectedvals[posId] = { summ: 0, quantity_protocol: 0 };
                    }
                    selectedvals[posId].summ += sum;
                    selectedvals[posId].quantity_protocol += q;
                    // per-app
                    const perAppKey = qKey;
                    selectedvals[posId][perAppKey] = (selectedvals[posId][perAppKey] || 0) + q;
                });
                
                // обновим визуально этот winner-grid
                try { grid.refresh(); } catch (e) { /* noop */ }
            });
            
            // Применяем агрегаты к основному гриду positions
            w2ui.positions.records.forEach(item => {
                // исходная полная quantity для позиции
                const baseQuantity = parseFloat(item.quantity || 0) || 0;
                
                // Сбросим пер-app поля (не трогаем общий quantity_protocol тут)
                Object.keys(item).forEach(k => {
                    if (k.startsWith('quantity_protocol') && k !== 'quantity_protocol') {
                        // устанавливаем 0 для всех quantity_protocol{appId}
                        item[k] = 0;
                    }
                });
                
                // по умолчанию общий остаток = исходная quantity (до вычитания распределенного)
                item.quantity_protocol = baseQuantity;
                
                const agg = selectedvals[item.id];
                if (agg) {
                    // общий остаток = quantity - суммарно распределённое по всем app
                    const distributed = parseFloat(agg.quantity_protocol || 0) || 0;
                    item.quantity_protocol = baseQuantity - distributed;
                    if (item.quantity_protocol < 0) item.quantity_protocol = 0;
                    
                    // восстановим per-app распределения
                    Object.keys(agg).forEach(k => {
                        if (k.startsWith('quantity_protocol')) {
                            item[k] = agg[k];
                        }
                    });
                }
            });
            
            // обновляем основной грид
            try { w2ui.positions.refresh(); } catch (e) { /* noop */ }
            
            summ_current = Object.keys(selectedvals).reduce((acc, pid) => {
                return acc + (parseFloat(selectedvals[pid].summ) || 0);
            }, 0);
            
            
            this.calcOptimumMin((summ_opt) => {
                this.applyTotals(summ_opt, summ_current, summ_ower)
            });
        },
        
        calcOptimumMin(callback) {
            // 1) Берём записи из основного грид
            const grid = w2ui.positions;
            if (!grid || !Array.isArray(grid.records)) {
                if (typeof callback === 'function') callback(0);
                return 0;
            }
            
            const positions = grid.records.map(rec => {
                const quantityTotal = parseFloat(rec.quantity ?? 0) || 0;
                
                const app = Object.keys(rec)
                    .filter(k => k.startsWith('Price_'))
                    .map(k => {
                        const appId = k.slice(6); // 'Price_123' -> '123'
                        const price = parseFloat(rec[k] ?? 0) || 0;
                        const qApp  = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0;
                        return { app_id: appId, price, quantity: qApp };
                    })
                    .filter(x => x.quantity > 0)
                    .sort((a, b) => a.price - b.price);
                
                return {
                    id: rec.id ?? rec.recid,
                    quantitytotal: quantityTotal,
                    app
                };
            });
            
            let totalSum = 0;
            for (const pos of positions) {
                let remaining = pos.quantitytotal;
                if (!remaining || pos.app.length === 0) continue;
                
                for (const offer of pos.app) {
                    if (remaining <= 0) break;
                    const buy = Math.min(remaining, offer.quantity);
                    if (buy > 0) {
                        totalSum += buy * offer.price;
                        remaining -= buy;
                    }
                }
            }
            
            if (typeof callback === 'function') callback(totalSum);
            return totalSum;
        },
        
        applyTotals(summ_opt, summ_current, summ_ower) {
            this.protocol.calculated_sum = {
                "opt_sum" : summ_opt,
                'cur_sum' : summ_current,
                'over_sum' : summ_ower
            }
        },
        
        recAdded(gridName, contragentId, rec, title) {
            // 1) уже есть в этом гриде (дубли)
            const grid = w2ui[gridName];
            if (grid && Array.isArray(grid.records)) {
                const idx = grid.records.findIndex(r => String(r.id) === String(rec.id));
                if (idx !== -1) {
                    w2popup.open({
                        title: 'Запис вже вибрана',
                        body: `<div class="w2ui-centered">Контрагент ${title}<br>рядок - ${idx + 1}</div>`
                    });
                    return true;
                }
            }
            
            // 2) позиция УЖЕ РАСПРЕДЕЛЕНА куда-либо (есть любое quantity_protocol{digits} > 0)
            const distributedTo = Object.entries(rec)
                .filter(([k, v]) => /^quantity_protocol\d+$/.test(k) && (parseFloat(v) || 0) > 0)
                .map(([k, v]) => ({ appId: k.replace('quantity_protocol', ''), qty: parseFloat(v) || 0 }));
            
            if (distributedTo.length > 0) {
                // красивый список: ID и количество (других названий у нас тут нет)
                const listHtml = distributedTo
                    .map(d => `${this.getAppTitle(d.appId)}: ${d.qty}`)
                    .join('<br>');
                
                w2popup.open({
                    title: 'Відмова',
                    body: `<div class="w2ui-centered">    Позицію вже розподілено:<br>${listHtml} </div>`
                });
                return true;
            }
            
            // можно добавлять
            return false;
        },
        
        fix_caption(items) {
            return items.map(item => {
                if(item.hasOwnProperty("caption")) {
                    item.text = item.caption;
                }
                
                return item;
            })
        },
        
        addButtonToolbar() {
            const self = this
            const add = (id, text) =>
                w2ui.positions.toolbar.add({
                    type: 'check', id, text, icon: 'w2ui-icon-columns',
                    onClick: (event) => self.sh_col(event)
                })
            
            add('quantity_', '"Кількість"')
            add('quantity_protocol', '"Кількість Протокол"')
            add('price', '"Ціна(грн)"')
            add('price_val_', '"Ціна(валюта)"')
            add('app', '"Сума(грн)"')
            add('comment', '"Коментар"')
            
            const ids = ['comment', 'quantity_protocol', 'price_val_'];
            ids.forEach(id => {
                w2ui.positions.toolbar.set(id, { checked: true });
                this.sh_col({ object: { id } });
            });
            
            w2ui.positions.toolbar.refresh();
        },
        
        sh_col(event) {
            const id = event.object.id
            const reg = new RegExp(id + '(\\d+)')
            w2ui.positions.columns.forEach((col) => {
                if (reg.test(col.field)) col.hidden = !col.hidden
            })
            w2ui.positions.refreshBody()
            w2ui.positions.resizeRecords()
        },
        
        fixNumber() {
            if (window.w2utils?.formatNumber) {
                const orig = w2utils.formatNumber
                w2utils.formatNumber = function (val, fraction, useGrouping) {
                    if (useGrouping !== true && useGrouping !== false) useGrouping = false
                    return orig.call(this, val, fraction, useGrouping)
                }
            }
        },
        
        getAppTitle(appId) {
            const appField = 'app' + appId;
            const col = (w2ui.positions?.columns || []).find(c => c.field === appField) || {};
            return col.app_title || col.caption || col.text || ('Контрагент ' + appId);
        },
    },
    
    computed: {
        position_data() {
            return this.protocol?.positions || null
        },
        
        columns() {
            return this.position_data?.columns || []
        },
        
        columnGroups() {
            return this.position_data?.columnGroups || []
        },
        
        records() {
            return this.position_data?.records || []
        },
    }
}
</script>

<style scoped>
/* по желанию */
</style>